import { createRouter, createWebHistory } from 'vue-router'
import { useSecurityStore } from '@/stores/store_security'
import GeneralDataView from '@/views/GeneralDataView.vue'
import PhotovoltaicProductionView from '@/views/PhotovoltaicProductionView.vue'
import ElectricityConsumptionView from '@/views/ElectricityConsumptionView.vue'
import WaterManagementView from '@/views/WaterManagementView.vue'
import WasteManagementView from '@/views/WasteManagementView.vue'
import TextView from '@/views/TextView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/data',
      name: 'data',
      component: GeneralDataView,
    },
    {
      path: '/electricite',
      name: 'electricity',
      component: ElectricityConsumptionView,
    },
    {
      path: '/solaire',
      name: 'solar',
      component: PhotovoltaicProductionView,
    },
    {
      path: '/eau',
      name: 'water',
      component: WaterManagementView,
    },
    {
      path: '/dechet',
      name: 'waste',
      component: WasteManagementView,
    },
    {
      path: '/texte',
      name: 'text',
      component: TextView,
    },
  ],
})

export default router
